import { useRedirectAfterLogin } from './useRedirectAfterLogin'
import { useToken } from './useToken'
import { useRoute } from 'vue-router'
import { AuthRoutesNames } from '@/router'
import { computed } from 'vue'

export const useValidateToken = () => {
  const route = useRoute()

  const validateToken = () => {
    const { redirect } = useRedirectAfterLogin()
    const { getToken } = useToken()

    const token = getToken()

    const confirmUserQueryParam = route.query?.confirmed

    const isConfirmUser = computed(() => confirmUserQueryParam === 'true')

    const excludedRoutes = [
      AuthRoutesNames.logout,
      AuthRoutesNames.userAgreement,
      AuthRoutesNames.privacyPolicy,
    ]

    const queryIsEmpty = computed(() => Object.keys(route.query).length === 0)

    if (
      isConfirmUser.value ||
      (!excludedRoutes.includes(route.name as string) && queryIsEmpty.value) ||
      (queryIsEmpty.value && token)
    ) {
      redirect()
    }
  }

  return { validateToken }
}
